import { createSvgIcon } from '@mui/material';

const IconNational = createSvgIcon(
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="50" rx="25" fill="#f7f8f8" />
    <g transform="translate(13, 13)">
      <circle cx="12" cy="12" r="10" stroke="#9697af" strokeWidth="1.5" fill="none" />
      <path
        d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20"
        stroke="#9697af"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>,
  'IconNational',
);

export default IconNational;
